class HomeProductHighlight extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
  }

  connectedCallback() {
    this.cards = Array.from(
      this.querySelectorAll('.section-home-product-highlight__card')
    );
    this.totalCards = this.cards.length;

    if (this.totalCards === 0) return;

    this.prevBtn = this.querySelector(
      '.section-home-product-highlight__nav-btn--prev'
    );
    this.nextBtn = this.querySelector(
      '.section-home-product-highlight__nav-btn--next'
    );

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.navigate(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.navigate(1));
    }

    this.desktopMQ = window.matchMedia('(min-width: 990px)');
    this.desktopMQ.addEventListener('change', () => this.updateView());
    this.updateView();
  }

  navigate(direction) {
    this.currentIndex =
      (this.currentIndex + direction + this.totalCards) % this.totalCards;
    this.updateStack();
  }

  updateView() {
    if (this.desktopMQ.matches) {
      this.updateStack();
    } else {
      this.clearStack();
    }
  }

  updateStack() {
    this.cards.forEach((card, i) => {
      const offset =
        (i - this.currentIndex + this.totalCards) % this.totalCards;
      card.setAttribute(
        'data-stack',
        offset < 4 ? String(offset) : 'hidden'
      );
    });
  }

  clearStack() {
    this.cards.forEach((card) => card.removeAttribute('data-stack'));
  }
}

if (!customElements.get('home-product-highlight')) {
  customElements.define('home-product-highlight', HomeProductHighlight);
}
